var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRibbonSilver(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 56,
    viewBox: "0 0 38 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ribbon silver 1",
    clipPath: "url(#clip0_578_401909)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cert-silver"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ribbon-silver"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9831 55.7703L18.9763 51.6954V33.2988H9.35132V54.7933C9.35132 55.6035 10.25 56.1516 10.9831 55.7703Z",
    fill: "#00ACEE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-1",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.9459 55.7703L18.9526 51.6954V33.2988H28.554V54.7933C28.5776 55.6035 27.7026 56.1516 26.9459 55.7703Z",
    fill: "#009AD5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.35132 27.7944V35.6821C9.35132 36.5161 10.8175 37.3978 11.6689 37.3978L14.4358 37.9221L16.8006 39.2804C18.1486 40.0668 19.7804 40.0668 21.1283 39.2804L23.4932 37.9221L26.2601 37.3978C27.0878 37.3978 28.5777 36.6115 28.5777 35.6821V27.7944H9.35132Z",
    fill: "#007BAA"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-9",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.2803 16.8564L30.0202 4.13131C29.2398 2.77301 27.8209 1.93896 26.2601 1.93896H11.6688C10.108 1.93896 8.68911 2.77301 7.9087 4.13131L0.672218 16.8564C-0.108187 18.2147 -0.108187 19.859 0.672218 21.2173L7.9087 33.9185C8.68911 35.2768 10.108 36.1109 11.6688 36.1109H26.2601C27.8209 36.1109 29.2398 35.2768 30.0202 33.9185L37.2567 21.2173C38.0371 19.859 38.0371 18.1909 37.2803 16.8564Z",
    fill: "#A3BFCE"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Fill-12",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8007 0.580704L4.19594 7.87262C2.84797 8.659 2.02026 10.0888 2.02026 11.6616V26.3645C2.02026 27.9373 2.84797 29.3671 4.19594 30.1535L16.8007 37.4454C18.1486 38.2318 19.7804 38.2318 21.1284 37.4454L33.7331 30.1535C35.0811 29.3671 35.9088 27.9373 35.9088 26.3645V11.6616C35.9088 10.0888 35.0811 8.659 33.7331 7.87262L21.1284 0.580704C19.7804 -0.181849 18.1486 -0.181849 16.8007 0.580704Z",
    fill: "#A3BFCE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-14",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.3682 6.51437L30.0202 4.13139C29.2398 2.77309 27.8209 1.93905 26.2601 1.93905H23.4932L21.1283 0.580754C19.7803 -0.205629 18.1486 -0.205629 16.8006 0.580754L14.4357 1.93905H11.6688C10.108 1.93905 8.68911 2.77309 7.9087 4.13139L6.56073 6.51437L4.19587 7.87267C2.84789 8.65905 2.02019 10.0888 2.02019 11.6616V14.4497L0.672218 16.8327C-0.108187 18.191 -0.108187 19.8352 0.672218 21.1935L2.02019 23.5765V26.3646C2.02019 27.9373 2.84789 29.3671 4.19587 30.1535L6.56073 31.5118V31.5356L31.3682 6.51437Z",
    fill: "#AFCDDB"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-17",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.50659 19.0252C7.50659 25.4116 12.6383 30.5827 18.9762 30.5827C25.314 30.5827 30.4458 25.4116 30.4458 19.0252C30.4458 12.6388 25.314 7.46777 18.9762 7.46777C12.6383 7.46777 7.50659 12.6388 7.50659 19.0252Z",
    fill: "url(#paint0_linear_578_401909)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-28"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-20",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9762 9.68369C24.6519 9.68369 29.287 14.3305 29.5235 19.5016C29.5235 19.3347 29.5472 19.1918 29.5472 19.025C29.5472 13.139 24.8174 8.37305 18.9762 8.37305C13.135 8.37305 8.40527 13.139 8.40527 19.025C8.40527 19.1918 8.40527 19.3347 8.42892 19.5016C8.66541 14.3305 13.2769 9.68369 18.9762 9.68369Z",
    fill: "#7896A0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-22",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9763 29.6767C13.1351 29.6767 8.40539 24.9108 8.40539 19.0248C8.40539 13.1388 13.1351 8.37288 18.9763 8.37288C24.8175 8.37288 29.5473 13.1388 29.5473 19.0248C29.5473 24.9108 24.7939 29.6767 18.9763 29.6767ZM18.9763 6.51416C12.1182 6.51416 6.56079 12.1142 6.56079 19.0248C6.56079 25.9354 12.1182 31.5354 18.9763 31.5354C25.8344 31.5354 31.3919 25.9354 31.3919 19.0248C31.3682 12.1142 25.8108 6.51416 18.9763 6.51416Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-24",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3547 13.2582L20.9391 16.5229C21.0101 16.642 21.1283 16.7374 21.2702 16.7612L24.8412 17.2855C25.1959 17.3331 25.3378 17.7859 25.0776 18.0242L22.4999 20.5501C22.4053 20.6455 22.358 20.7884 22.3817 20.9314L22.9966 24.5059C23.0675 24.8633 22.6891 25.1255 22.3817 24.9586L19.1891 23.2667C19.0709 23.1952 18.9053 23.1952 18.7871 23.2667L15.5945 24.9586C15.2871 25.1255 14.9087 24.8633 14.9797 24.5059L15.5945 20.9314C15.6182 20.7884 15.5709 20.6455 15.4763 20.5501L12.8513 18.0242C12.5912 17.762 12.733 17.3331 13.0878 17.2855L16.6587 16.7612C16.8006 16.7374 16.9189 16.642 16.9898 16.5229L18.5743 13.2582C18.7398 12.9484 19.1891 12.9484 19.3547 13.2582Z",
    fill: "#AFCDDB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-26",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.9562 17.0468L23.5406 16.6417C23.6116 16.6179 23.6116 16.5225 23.5406 16.4987L21.9562 16.0936C21.767 16.0459 21.6487 15.903 21.6014 15.7362L21.1994 14.1396C21.1758 14.0681 21.0812 14.0681 21.0575 14.1396L20.6555 15.7362C20.6082 15.9268 20.4663 16.0459 20.3008 16.0936L18.7163 16.4987C18.6453 16.5225 18.6453 16.6179 18.7163 16.6417L20.3008 17.0468C20.4899 17.0944 20.6082 17.2374 20.6555 17.4042L21.0575 19.0008C21.0812 19.0723 21.1758 19.0723 21.1994 19.0008L21.6014 17.4042C21.6251 17.2136 21.767 17.0706 21.9562 17.0468Z",
    fill: "white"
  }))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_578_401909",
    x1: 18.9667,
    y1: 7.4765,
    x2: 18.9667,
    y2: 30.5769,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9EBAC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8EAAB6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_578_401909"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37.8378,
    height: 56,
    fill: "white",
    transform: "translate(0.0810547)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRibbonSilver);
export default __webpack_public_path__ + "static/media/ribbonSilver.81773ffb1bd151ddff509e772d236535.svg";
export { ForwardRef as ReactComponent };